import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600 via-primary-500 to-accent-500"></div>
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
              Ready to Make a{' '}
              <span className="text-accent-300">Difference?</span>
            </h2>
            <p className="text-white/80 text-sm md:text-base leading-relaxed max-w-lg mb-8">
              Join thousands of donors and volunteers creating lasting change. Whether you donate, volunteer, or start a fundraiser — every action counts.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <Link
                to="/donate"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-white text-primary-600 font-semibold rounded-full hover:bg-white/90 transition-all duration-300 whitespace-nowrap text-sm md:text-base shadow-lg"
              >
                <i className="ri-heart-line text-lg"></i>
                Donate Now
              </Link>
              <Link
                to="/volunteer"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-white/15 backdrop-blur-sm text-white font-semibold rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap border border-white/30 text-sm md:text-base"
              >
                <i className="ri-user-heart-line text-lg"></i>
                Become a Volunteer
              </Link>
              <Link
                to="/start-fundraiser"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-white/15 backdrop-blur-sm text-white font-semibold rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap border border-white/30 text-sm md:text-base"
              >
                <i className="ri-flag-line text-lg"></i>
                Start Fundraiser
              </Link>
            </div>
          </div>

          <div className="flex-1 flex justify-center lg:justify-end">
            <div className="glass-card-strong rounded-3xl p-6 md:p-8 max-w-sm">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-4">Become a Monthly Donor</h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-5">
                Small monthly contributions create big, sustained impact. Your recurring donation supports ongoing programs throughout the year.
              </p>
              <div className="space-y-3 mb-5">
                {['₹250/month - Supports 1 child\'s education', '₹500/month - Feeds a family of 4', '₹1000/month - Healthcare for 10 seniors'].map((text, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-secondary-500 text-sm"></i>
                    <span className="text-foreground-600 text-xs">{text}</span>
                  </div>
                ))}
              </div>
              <Link
                to="/monthly-giving"
                className="block w-full text-center py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
              >
                Join Monthly Giving
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}